import "./style.scss";

function Header({ isVariant = false, activeIndex = 0 }) {
  const links = [
    { title: "Home", url: "/" },
    { title: "Products", url: "/products" },
    { title: "Downloads", url: "/downloads" },
    { title: "Know Us", url: "/about" },
    { title: "Press", url: "/press" },
    { title: "OEM", url: "/oem" },
  ];

  // Function to handle tracking of the WhatsApp click
  const trackWhatsAppClick = () => {
    // For example, you can log the event to the console or integrate with Google Analytics
    console.log('WhatsApp link clicked!');
    
    // Optionally, you could send the event to Google Analytics or another service:
    // gtag('event', 'click', { 'event_category': 'social', 'event_label': 'WhatsApp' });

    // Then, navigate to the WhatsApp link
    window.open("https://wa.me/+919409767676", "_blank");
  };

  return (
    <>
      <div
        className={
          isVariant ? "header container fixVariant" : "header container"
        }
      >
        <div className="logo" onClick={() => (window.location = "/")}>
          <SvgLogo />
        </div>
        <div className="fgrow"></div>
        <div className="menu">
      {links.map((item, index) => {
  const isExternal = item.url.startsWith("http");
  return (
    <a
      key={"header_link_" + index}
      href={item.url}
      className={index === activeIndex ? "active" : ""}
      target={isExternal ? "_blank" : "_self"}
      rel={isExternal ? "noreferrer" : undefined}
    >
      {item.title}
    </a>
  );
})}
        
          <MobileMenu active={activeIndex} menu={links} />
        </div>
      </div>
      <a className="whatme"
  href="https://wa.me/+919409767676"
  target="_blank"
  rel="noopener noreferrer"
  onClick={() => { console.log("WhatsApp link clicked!"); }}>
        <SvgWhatsApp />
      </a>
    </>
  );
}


function MobileMenu(props) {
  let menu = props["menu"];
  let activeIndex = props["active"];

  function onOpen() {
    let obj = document.querySelector(".mobile_menu .drop_down");
    obj.style.animation = "fadeIn 500ms";
    obj.style.display = "block";
  }

  function onClose() {
    let obj = document.querySelector(".mobile_menu .drop_down");
    obj.style.animation = "fadeOut 500ms";
    setTimeout(() => {
      obj.style.display = "none";
    }, 450);
  }

  return (
    <>
      <div className="mobile_menu">
        <div onClick={() => onOpen()}>
          <SvgMenuIcon />
        </div>
        <div className="drop_down">
          <div onClick={() => onClose()} className="f-flex">
            <h5>CLOSE</h5>
            <div>
              <SvgClose />
            </div>
          </div>
          {menu.map((item, index) => {
            return (
              <a
                key={"mobile_link_" + index}
                href={item["url"]}
                className={index === activeIndex ? "active" : ""}
              >
                {item["title"]}
              </a>
            );
          })}
        </div>
      </div>
    </>
  );
}

function SvgClose() {
  return (
    <svg
      alt={"close icon"}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 47.971 47.971"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88
		c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242
		C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879
		s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z"
        />
      </g>
    </svg>
  );
}

function SvgMenuIcon() {
  return (
    <svg
      alt={"menu icon"}
      width="40px"
      height="40px"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.8334 6.5H4.5M25.8334 15.5H15.5M25.8334 24.5H4.5"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgLogo() {
  return (
    <svg
      alt={"n labs logo"}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      viewBox="0 0 1024 1024"
    >
      <g transform="matrix(1.88 1.08 -1.08 1.87 526.16 452.41)" id="logo-logo">
        <g transform="matrix(0.35 0 0 -0.35 -30.61 -26.26)" id="logo-logo">
          <path
            className="logo_fill"
            style={{
              stroke: "none",
              strokeWidth: 1,
              strokeDasharray: "none",
              strokeLinecap: "butt",
              strokeDashoffset: 0,
              strokeLinejoin: "miter",
              strokeMiterlimit: 10,
              fillRule: "nonzero",
              opacity: 1,
            }}
            paintOrder="stroke"
            transform=" translate(-726.04, -1374.72)"
            d="m 903.633 1228.46 l 56.172 416.04 l -24.602 -44.46 l -122.058 70.47 l -320.872 -185.26 v -370.52 l 62.012 -35.79 l 73.449 465.49 l 156.668 -23.05 l 119.231 -292.92"
            strokeLinecap="round"
          />
        </g>
        <g transform="matrix(0.35 0 0 -0.35 30.19 26.2)" id="logo-logo">
          <path
            className="logo_fill"
            style={{
              stroke: "none",
              strokeWidth: 1,
              strokeDasharray: "none",
              strokeLinecap: "butt",
              strokeDashoffset: 0,
              strokeLinejoin: "miter",
              strokeMiterlimit: 10,
              fillRule: "nonzero",
              opacity: 1,
            }}
            paintOrder="stroke"
            transform=" translate(-899.06, -1225.44)"
            d="m 1071.45 1521.38 l -72.231 -457.81 l -147.996 15.37 c 0 0 -126.379 296.55 -129.219 308.15 l -57.902 -430.305 l 24.753 44.455 l -0.046 0.04 l 124.336 -71.788 l 320.875 185.238 v 370.52 l -62.57 36.13"
            strokeLinecap="round"
          />
        </g>
      </g>
      <g transform="matrix(1.58 0 0 1.58 526.16 804.04)">
        <filter id="SVGID_159370" y="-20%" height="140%" x="-20%" width="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="0"></feGaussianBlur>
          <feOffset dx="0" dy="0" result="oBlur"></feOffset>
          <feFlood floodColor="rgb(0,0,0)" floodOpacity="1" />
          <feComposite in2="oBlur" operator="in" />
          <feMerge>
            <feMergeNode></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
        <path
          className="logo_fill"
          style={{
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 10,
            fillRule: "nonzero",
            opacity: 1,
            filter: "url(#SVGID_159370)",
          }}
          paintOrder="stroke"
          transform=" translate(-288.12, 34.85)"
          d="M 45.64 0 L 4.44 0 L 4.44 -13.77 L 15.99 -13.77 L 15.99 -55.93 L 4.44 -55.93 L 4.44 -68.72 L 38.05 -68.72 L 77.23 -32.63 L 77.23 -55.93 L 65.69 -55.93 L 65.69 -68.72 L 106.88 -68.72 L 106.88 -55.93 L 94.9 -55.93 L 94.9 0 L 80.38 0 L 33.66 -41.95 L 33.66 -13.77 L 45.64 -13.77 L 45.64 0 Z M 159.51 -30.73 L 129.75 -30.73 L 129.75 -39.73 L 159.51 -39.73 L 159.51 -30.73 Z M 268.88 0 L 182.22 0 L 182.22 -13.77 L 193.76 -13.77 L 193.76 -55.93 L 182.22 -55.93 L 182.22 -68.72 L 228.72 -68.72 L 228.72 -55.93 L 216.74 -55.93 L 216.74 -13.77 L 253.6 -13.77 L 253.6 -26.77 L 268.88 -26.77 L 268.88 0 Z M 316.74 0 L 275.55 0 L 275.55 -13.77 L 289.53 -13.77 L 323.95 -68.4 L 338.37 -72.14 L 371.92 -13.77 L 380.64 -13.77 L 380.64 0 L 339.5 0 L 339.5 -13.77 L 344.82 -13.77 L 342.38 -18.54 L 312.84 -18.54 L 310.07 -13.77 L 316.74 -13.77 L 316.74 0 Z M 328.72 -45.04 L 320.37 -31.16 L 335.82 -31.16 L 328.72 -45.04 Z M 438.36 0 L 387.31 0 L 387.31 -13.77 L 398.85 -13.77 L 398.85 -55.93 L 387.31 -55.93 L 387.31 -68.72 L 440.8 -68.72 Q 444.92 -68.72 448.12 -68.56 Q 451.32 -68.4 454.89 -67.94 Q 458.47 -67.48 461.13 -66.67 Q 463.78 -65.85 466.28 -64.47 Q 468.77 -63.09 470.37 -61.16 Q 471.97 -59.24 472.92 -56.5 Q 473.86 -53.77 473.86 -50.3 L 473.86 -50.3 Q 473.86 -43.9 468.66 -39.4 L 468.66 -39.4 Q 480.53 -34.74 480.53 -21.3 L 480.53 -21.3 Q 480.53 -17.24 479.2 -14.01 Q 477.87 -10.79 475.73 -8.59 Q 473.59 -6.4 470.23 -4.77 Q 466.87 -3.14 463.46 -2.25 Q 460.04 -1.35 455.46 -0.84 Q 450.88 -0.33 447.06 -0.16 Q 443.24 0 438.36 0 L 438.36 0 Z M 421.83 -29.86 L 421.83 -13.77 L 438.8 -13.77 Q 445.9 -13.77 449.53 -14.55 Q 453.16 -15.34 454.41 -16.86 Q 455.65 -18.37 455.65 -21.3 L 455.65 -21.3 Q 455.65 -26.83 452.21 -28.35 Q 448.77 -29.86 437.5 -29.86 L 437.5 -29.86 L 421.83 -29.86 Z M 421.83 -55.93 L 421.83 -42.49 L 447.25 -42.49 Q 450.34 -43.47 450.34 -48.51 L 450.34 -48.51 Q 450.34 -51.06 449.61 -52.6 Q 448.88 -54.15 447.28 -54.85 Q 445.68 -55.55 444.16 -55.74 Q 442.65 -55.93 440.04 -55.93 L 440.04 -55.93 L 421.83 -55.93 Z M 504.76 0.43 L 489.42 0.43 L 489.42 -27.42 L 504.76 -27.42 L 504.76 -23.41 Q 504.76 -20.16 507.41 -17.78 Q 510.07 -15.39 514.49 -14.2 Q 518.9 -13.01 523.4 -12.49 Q 527.9 -11.98 532.83 -11.98 L 532.83 -11.98 Q 535.49 -11.98 538.14 -12.33 Q 540.8 -12.68 543.27 -13.39 Q 545.73 -14.09 547.28 -15.42 Q 548.82 -16.75 548.82 -18.43 L 548.82 -18.43 Q 548.82 -19.84 548.31 -20.84 Q 547.79 -21.84 546.54 -22.49 Q 545.3 -23.14 543.86 -23.52 Q 542.43 -23.9 539.96 -24.17 Q 537.49 -24.44 535.19 -24.61 Q 532.89 -24.77 529.26 -25.12 Q 525.62 -25.47 522.48 -25.85 L 522.48 -25.85 Q 520.31 -26.12 518.14 -26.53 Q 515.98 -26.94 512.75 -27.8 Q 509.53 -28.67 506.76 -29.78 Q 504 -30.89 501.07 -32.68 Q 498.15 -34.47 496.11 -36.61 Q 494.08 -38.75 492.75 -41.81 Q 491.42 -44.88 491.42 -48.4 L 491.42 -48.4 Q 491.42 -52.9 493.05 -56.64 Q 494.68 -60.38 497.55 -62.87 Q 500.42 -65.36 503.94 -67.18 Q 507.47 -69 511.69 -70 Q 515.92 -71 519.88 -71.46 Q 523.84 -71.92 527.85 -71.92 L 527.85 -71.92 Q 535.27 -71.92 543.37 -69.67 Q 551.48 -67.42 555.7 -64.5 L 555.7 -64.5 L 555.7 -69.92 L 570.99 -69.92 L 570.99 -43.2 L 555.7 -43.2 L 555.7 -47.15 Q 555.7 -49.7 553.24 -51.79 Q 550.77 -53.87 546.9 -55.07 Q 543.02 -56.26 538.77 -56.88 Q 534.51 -57.51 530.5 -57.51 L 530.5 -57.51 Q 521.13 -57.51 517.66 -56.18 Q 514.19 -54.85 514.19 -50.73 L 514.19 -50.73 Q 514.19 -49.81 514.78 -49.16 Q 515.38 -48.51 516.76 -48.05 Q 518.14 -47.59 519.28 -47.34 Q 520.42 -47.1 522.59 -46.72 L 522.59 -46.72 Q 525.46 -46.18 529.93 -45.69 Q 534.4 -45.2 538.06 -44.88 Q 541.72 -44.55 546.17 -43.79 Q 550.61 -43.03 554.11 -42.03 Q 557.6 -41.03 561.04 -39.19 Q 564.48 -37.34 566.73 -34.85 Q 568.98 -32.36 570.39 -28.56 Q 571.8 -24.77 571.8 -20 L 571.8 -20 Q 571.8 -9.43 561.59 -3.5 Q 551.37 2.44 530.94 2.44 L 530.94 2.44 Q 522.97 2.44 516.06 1.08 Q 509.15 -0.27 504.76 -2.55 L 504.76 -2.55 L 504.76 0.43 Z"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}

function SvgWhatsApp() {
  return (
    <svg
      alt={"message image"}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1219.547 1225.016"
      width="55px"
      height="55px"
    >
      <path
        fill="#E0E0E0"
        d="M1041.858 178.02C927.206 63.289 774.753.07 612.325 0 277.617 0 5.232 272.298 5.098 606.991c-.039 106.986 27.915 211.42 81.048 303.476L0 1225.016l321.898-84.406c88.689 48.368 188.547 73.855 290.166 73.896h.258.003c334.654 0 607.08-272.346 607.222-607.023.056-162.208-63.052-314.724-177.689-429.463zm-429.533 933.963h-.197c-90.578-.048-179.402-24.366-256.878-70.339l-18.438-10.93-191.021 50.083 51-186.176-12.013-19.087c-50.525-80.336-77.198-173.175-77.16-268.504.111-278.186 226.507-504.503 504.898-504.503 134.812.056 261.519 52.604 356.814 147.965 95.289 95.36 147.728 222.128 147.688 356.948-.118 278.195-226.522 504.543-504.693 504.543z"
      />
      <linearGradient
        id="a"
        gradientUnits="userSpaceOnUse"
        x1="609.77"
        y1="1190.114"
        x2="609.77"
        y2="21.084"
      >
        <stop offset="0" stopColor="#20b038" />
        <stop offset="1" stopColor="#60d66a" />
      </linearGradient>
      <path
        fill="url(#a)"
        d="M27.875 1190.114l82.211-300.18c-50.719-87.852-77.391-187.523-77.359-289.602.133-319.398 260.078-579.25 579.469-579.25 155.016.07 300.508 60.398 409.898 169.891 109.414 109.492 169.633 255.031 169.57 409.812-.133 319.406-260.094 579.281-579.445 579.281-.023 0 .016 0 0 0h-.258c-96.977-.031-192.266-24.375-276.898-70.5l-307.188 80.548z"
      />
      <image
        overflow="visible"
        opacity=".08"
        width="682"
        height="639"
        xlinkHref="FCC0802E2AF8A915.png"
        transform="translate(270.984 291.372)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFF"
        d="M462.273 349.294c-11.234-24.977-23.062-25.477-33.75-25.914-8.742-.375-18.75-.352-28.742-.352-10 0-26.25 3.758-39.992 18.766-13.75 15.008-52.5 51.289-52.5 125.078 0 73.797 53.75 145.102 61.242 155.117 7.5 10 103.758 166.266 256.203 226.383 126.695 49.961 152.477 40.023 179.977 37.523s88.734-36.273 101.234-71.297c12.5-35.016 12.5-65.031 8.75-71.305-3.75-6.25-13.75-10-28.75-17.5s-88.734-43.789-102.484-48.789-23.75-7.5-33.75 7.516c-10 15-38.727 48.773-47.477 58.773-8.75 10.023-17.5 11.273-32.5 3.773-15-7.523-63.305-23.344-120.609-74.438-44.586-39.75-74.688-88.844-83.438-103.859-8.75-15-.938-23.125 6.586-30.602 6.734-6.719 15-17.508 22.5-26.266 7.484-8.758 9.984-15.008 14.984-25.008 5-10.016 2.5-18.773-1.25-26.273s-32.898-81.67-46.234-111.326z"
      />
      <path
        fill="#FFF"
        d="M1036.898 176.091C923.562 62.677 772.859.185 612.297.114 281.43.114 12.172 269.286 12.039 600.137 12 705.896 39.633 809.13 92.156 900.13L7 1211.067l318.203-83.438c87.672 47.812 186.383 73.008 286.836 73.047h.255.003c330.812 0 600.109-269.219 600.25-600.055.055-160.343-62.328-311.108-175.649-424.53zm-424.601 923.242h-.195c-89.539-.047-177.344-24.086-253.93-69.531l-18.227-10.805-188.828 49.508 50.414-184.039-11.875-18.867c-49.945-79.414-76.312-171.188-76.273-265.422.109-274.992 223.906-498.711 499.102-498.711 133.266.055 258.516 52 352.719 146.266 94.195 94.266 146.031 219.578 145.992 352.852-.118 274.999-223.923 498.749-498.899 498.749z"
      />
    </svg>
  );
}

export default Header;
